import * as applicationDataReviewActions from '../actions/applicationDataReviewActions';
const initialState = {};
export default (state = initialState, action) => {
  //NOSONAR
  if (action.type === applicationDataReviewActions.APP_DATA_REVIEW_RESPONSE) {
    return {
      ...state,
      responseData: {
        ...action.data,
      },
    };
  }
  return state;
};
